<template>
  <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
    <div class="fullPage">
    <!-- Buttons -->
    <div class="button-bar  row row-cols-2 row-cols-sm-2 g-2 p-3 bg-light m-0">
      <div class="col" v-for="button in buttons" :key="button.page">
        <button
          class="btn w-100"
          :class="currentPage === button.page ? button.activeClass : button.outlineClass"
          @click="currentPage = button.page"
        >
          {{ button.label }}
        </button>
      </div>
    </div>

    <!-- Page Content Area -->
    <div class="content-area">
      <div v-if="currentPage === 'student'">
        <StudentPayment />
      </div>

      <div v-else-if="currentPage === 'mypayment'">
        <MyPayment />
      </div>

    </div>
  </div>
  </div>
</template>

<script>
import StudentPayment from '@/components/TeacherDashboard/PaymentPages/StudentPayment.vue';
import MyPayment from '@/components/TeacherDashboard/PaymentPages/MyPayment.vue';

export default {
  components: {
    StudentPayment,
    MyPayment,
  },
  data() {
    return {
      currentPage: 'student',
      buttons: [
        {
          page: 'student',
          label: 'Student Payment',
          activeClass: 'btn-primary',
          outlineClass: 'btn-outline-primary'
        },
        {
          page: 'mypayment',
          label: 'My Payment',
          activeClass: 'btn-secondary',
          outlineClass: 'btn-outline-secondary'
        },
      ]
    };
  }
};
</script>

<style scoped>
.fullPage{
  width: 100%;
  height: 100%;
}



.button-bar{
  width: 100%;  
}


.content-area{
  margin-top: 5dvh;
      height: 100%;
}

/* Responsive tweaks */
@media (max-width: 768px) {

  .button-bar {
  /* position: fixed;
  width: 90dvw; */
  width: 100%;
}

}
</style>
